import { gql } from '@apollo/client';

export const GET_ENTERPRISE_CLASSIFICATION_QUERY = gql`
  query getEnterpriseClassificationsQuery {
    enterprise_classifications {
      id
      name
    }
  }
`;
